import React from 'react'
import './Header.scss'
import { motion } from 'framer-motion'
import { images } from '../../constants'
import { AppWrap } from '../../wrapper';

const Header = () => {
  const scalevariants = {
    whileInView: {
      scale: [0, 1],
      opacity: [0, 1],
      transition: {
        duration: 1,
        ease: 'easeInOut'
      }
    }
  }
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 1 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋</span>
            <div style={{ marginLeft: '20' }}>
              <p className='p-text'>Hello, I am</p>
              <h1 className='head-text'>Navid A Mulla</h1>
            </div>
          </div>

          <div className='tag-cmp app__flex'>
            <p className='p-text'>Full Stack Developer</p>
            <p className='p-text'>ROS Developer</p>
          </div>
        </div>

        <div style={{ padding:'1rem 1rem' }}>
          <div className=' app__EduInfo' >
            <p className='p-text'>
              M.Tech Robotic Engineering
            </p>
          </div>
          <div className='app__EduInfo' >
            <p className='p-text'>
              B.E Mechanical Engineering
            </p>
          </div>
        </div>

      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'>


        {/* <div className='app__EduInfo' style={{ position: 'relative', top: '-30rem', right: '20rem' }}> <p className='p-text'>
            M.Tech Robotic Engineering
          </p>
          </div>

          <div className='app__EduInfo' style={{ position: 'relative', top: '-20rem', right: '20rem' }}>
            <p className='p-text'>
              B.E Mechanical Engineering
            </p>
          </div> */}
        {/* </div> */}

        <img src={images.MyPic} alt="profile_bg" />
        <motion.img
          whileInView={{ sclae: [0, 1] }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle'
        />
      </motion.div>


      {/* make circle fall behind Dp */}
      <motion.div
        variants={scalevariants}
        whileInView={scalevariants.whileInView}
        className='app__header-circles'
      >
        {
          [
            images.ROS,
            images.python,
            images.react,
            images.node,
            // images.javascript,
            // images.git,
            // images.api,
          ].map((circle, index) => (
            <div className='circle-cmp app_flex' key={`circle-${index}`}>
              <img src={circle} alt="circle" />
            </div>

          ))
        }
        <div>

        </div>
      </motion.div>
    </div>

  )
}

export default AppWrap(Header, 'home')
